<template>
  <div class="d-flex flex-column align-items-center bg-white px-4 px-md-5 py-5 w-100" style="max-width: 495px">

    <h4 class="text-uppercase font-weight-bold mb-4">Sign up</h4>

    <b-form
      @submit.prevent="submit"
      novalidate ref="form"
      class="form-animated"
      :class="{'was-validated' : validation }">
      <b-row>
        <b-col v-for="(input, key) in inputs" :key="key" :md="input.columns">

          <b-form-group v-if="input.type === 'text' || input.type === 'email'" class="mb-4 position-relative">

            <b-form-input
              :id="input.name"
              :type="input.type"
              v-model="form[input.name]"
              :required="input.required"
              :class="{'input-filled' : !!form[input.name]}">
            </b-form-input>

            <div class="invalid-feedback position-absolute mt-0 text-left">
              Please provide a valid value
            </div>

            <label
              :for="input.name"
              class="label-animated">
              {{input.label}}
              <span v-if="input.required" class="text-danger">*</span>
            </label>

          </b-form-group>

          <b-form-group v-if="input.type === 'password'" class="mb-4 position-relative">

            <b-form-input
              :id="input.name"
              :type="inputTypeToggled"
              v-model="form[input.name]"
              :required="input.required"
              :class="{'input-filled' : !!form[input.name]}">
            </b-form-input>

            <label
              :for="input.name"
              class="label-animated">
              {{input.label}}
              <span v-if="input.required" class="text-danger">*</span>
            </label>

            <i class="fas position-absolute text-muted"
               :class="inputTypeToggled === 'password' ?  'fa-eye' : ' fa-eye-slash'"
               @click="togglePasswordVisibility"
               style="right: 8px; top: 6px"></i>

          </b-form-group>

          <b-form-group v-if="input.type === 'select'" class="mb-4 position-relative">

            <b-form-select
              :id="input.name"
              v-model="form[input.name]"
              :options="input.options"
              :class="{'input-filled' : !!form[input.name]}"
            ></b-form-select>

            <label
              :for="input.name"
              class="label-animated">
              {{input.label}}
            </label>

          </b-form-group>
        </b-col>
      </b-row>

      <b-btn
        variant="link"
        class="p-0"
        style="margin-top: -32px"
        size="sm"
      >
        <small><u>
          Enter Invitation Code
        </u></small>
      </b-btn>

      <b-btn
        class="text-uppercase w-100 p-2 mt-2"
        type="submit"
      >
        Sign up
      </b-btn>

      <div class="text-uppercase text-center mt-2">

        <small>By signing up I agree to</small>
        <b-btn
          variant="link"
          class="p-0 text-uppercase ml-1"
          style="margin-top: -3px"
        >
          <small><u>
            Terms and conditions
          </u></small>
        </b-btn>
      </div>

    </b-form>
  </div>
</template>

<script>
  export default {
    name: "registrationPopup",
    data() {
      return {
        validation: false,
        inputs: [
          {
            name: 'firstName',
            label: 'First name',
            type: 'text',
            columns: 6,
            required: true
          },
          {
            name: 'lastName',
            label: 'Last name',
            type: 'text',
            columns: 6,
            required: true
          },
          {
            name: 'company',
            label: 'Company',
            type: 'text',
            columns: 6,
            required: true
          },
          {
            name: 'job',
            label: 'Job title',
            type: 'text',
            columns: 6,
            required: true
          },
          {
            name: 'city',
            label: 'City',
            type: 'text',
            columns: 12,
            required: false
          },
          {
            name: 'country',
            label: 'Country',
            options: [
              {
                text: 'Moldova',
                value: 'Moldova'
              },
              {
                text: 'Ukraine',
                value: 'Ukraine'
              }
            ],
            type: 'select',
            columns: 12,
            required: false
          },
          {
            name: 'state',
            label: 'State',
            options: [
              {
                text: 'Moldova',
                value: 'Moldova'
              },
              {
                text: 'Ukraine',
                value: 'Ukraine'
              }
            ],
            type: 'select',
            columns: 12,
            required: false
          },
          {
            name: 'email',
            label: 'E-mail',
            type: 'email',
            columns: 12,
            required: true
          },
          {
            name: 'password',
            label: 'Password',
            type: 'password',
            columns: 6,
            required: true
          },
          {
            name: 'confirmPassword',
            label: 'Confirm Password',
            type: 'password',
            columns: 6,
            required: true
          }
        ],
        form: {
          firstName: '',
          lastName: '',
          company: '',
          job: '',
          city: '',
          country: '',
          state: '',
          email: '',
          password: '',
          confirmPassword: ''
        },
        inputTypeToggled: 'password'
      }
    },
    methods: {
      togglePasswordVisibility() {
        if (this.inputTypeToggled === 'password') {
          this.inputTypeToggled = 'text'
        } else {
          this.inputTypeToggled = 'password'
        }
      },
      submit() {
        this.validation = true;
        if (this.$refs.form.checkValidity()) {
          console.log('Success!')
        } else {
          console.log('Fail!')
        }
        console.log(this.form)
      }
    }
  }
</script>